export default __webpack_public_path__ + "static/media/428.2ae8a793.gif";